const colorList = [
  '#fe59a5',
  '#eb6569',
  '#d7a05c',
  '#27becb',
  '#3080e8',
  '#7e5bef',
  '#7ed321',
  '#f6a623',
  '#0db063',
  '#b1743e',
]

const stringToColor = (str) => colorList[stringToIndex(str)]

const stringToIndex = (str) => {
  let hash = 0
  let i, chr
  if (str.length === 0) {
    return hash
  }
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0
  }
  return Math.abs(hash % 10)
}

export { colorList, stringToIndex, stringToColor }



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/random-color/index.js